/* eslint-disable */
// https://savvyapps.com/blog/definitive-guide-building-web-app-vuejs-firebase

import { initializeApp } from "firebase/app";
import { initializeFirestore, collection, query, where, orderBy, limit,
  onSnapshot, deleteDoc, getDocs, doc, getDoc, setDoc, updateDoc, arrayUnion,
  addDoc, Timestamp, writeBatch, deleteField
} from "firebase/firestore";

import store from './index';
import { isDemoClaims } from '../utils/demo/demoSession';

import { getAuth, onAuthStateChanged, GoogleAuthProvider, signInWithPopup, signOut, signInWithCustomToken } from "firebase/auth";

// firebase init goes here - test
var firebaseConfig = {
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_FIREBASE_DB_URL,
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_FIREBASE_APP_ID
  };

//console.log(`firebaseConfig: ${JSON.stringify(firebaseConfig)}`);
// Initialize Firebase
//firebase.initializeApp(firebaseConfig);

// https://medium.com/firebase-developers/why-is-my-currentuser-null-in-firebase-auth-4701791f74f0


/*
firebase.auth().onIdTokenChanged(user => {
  //console.log(`Firebase Id Token Changed for user`);
  if(user) {    
    //console.dir(user);
  } else {
    //console.log(`onIdTokenChanged with no user`);    
    store.dispatch("customer/logout", {reload: false, msg: 'Your token has expired. Please login again'});
  }
});
*/

/*
firebase.auth().onAuthStateChanged(user => {
  console.log(`Firebase onAuthState Changed for user`);
  if(user) {    
    console.dir(user);
  } else {
    console.log(`no user`);
    //store.dispatch("customer/logout");
  }
});
*/

const firebase = initializeApp(firebaseConfig);
// Use long polling to avoid ad-blockers/extensions breaking WebChannel
const db = initializeFirestore(firebase, {
  experimentalAutoDetectLongPolling: true,
  useFetchStreams: false,
  // Silently strip `undefined` fields on writes instead of throwing.
  // Auto-generated tasks (e.g. workflow-spawned) can have absent fields like
  // createdByEmpID; without this, editing them via updateDoc() errors out.
  ignoreUndefinedProperties: true
});

const auth = getAuth();

onAuthStateChanged(auth, (user) => {
  if (user) {
    // User signed in. Demo site (Try Teamio): re-derive customer/isDemo from the token on every boot and every
    // sign-in, so a reload keeps it. A failed read keeps the current value (a network blip never flips it).
    user.getIdTokenResult()
      .then((r) => store.commit('customer/setIsDemo', isDemoClaims(r && r.claims)))
      .catch(() => {});
  } else {
    // User signed out - listeners are cleaned up in customer/logout action
    // before signOut is called, so no additional cleanup needed here
    store.commit('customer/setIsDemo', false);
  }
});


// firebase utils
//const db = firebase.firestore();
//const auth = firebase.default.auth();
//const currentUser = auth.currentUser

export {
    firebase,
    db,
    GoogleAuthProvider,
    signInWithPopup,
    getAuth,
    collection,
    query,
    where,
    orderBy,
    limit,
    onSnapshot,
    deleteDoc,
    getDocs,
    doc,
    getDoc,
    setDoc,
    signOut,
    updateDoc,
    arrayUnion,
    // Action Center: Clear all (batched readBy writes) and Undo (remove my readBy entry).
    writeBatch,
    deleteField
}

// =============================================================================
// TEST HOOK: Expose Firebase auth for E2E testing
// =============================================================================
// This allows Cypress/Playwright tests to sign in using the SAME Firebase
// instance that the app uses, ensuring realistic test behavior.
//
// SECURITY: Only enabled in development environment
// =============================================================================
if (process.env.NODE_ENV === 'development' || process.env.VUE_APP_NODE_ENV === 'development') {
    /**
     * Test hook for signing in with a Firebase custom token
     * @param {string} customToken - Firebase custom token from testLogin API
     * @returns {Promise<UserCredential>} - Firebase user credential
     */
    window.__TEAMIO_TEST_FIREBASE_SIGNIN__ = async (customToken) => {
        try {
            console.log('[TEST HOOK] Signing in with custom token...');
            const userCredential = await signInWithCustomToken(auth, customToken);
            console.log('[TEST HOOK] Firebase sign-in successful:', userCredential.user.uid);
            return {
                success: true,
                uid: userCredential.user.uid,
                email: userCredential.user.email
            };
        } catch (error) {
            console.error('[TEST HOOK] Firebase sign-in failed:', error);
            return {
                success: false,
                error: error.message,
                code: error.code
            };
        }
    };

    /**
     * Test hook for signing out
     * @returns {Promise<Object>} - Result object
     */
    window.__TEAMIO_TEST_FIREBASE_SIGNOUT__ = async () => {
        try {
            await signOut(auth);
            console.log('[TEST HOOK] Firebase sign-out successful');
            return { success: true };
        } catch (error) {
            console.error('[TEST HOOK] Firebase sign-out failed:', error);
            return { success: false, error: error.message };
        }
    };

    /**
     * Test hook to check current auth state
     * @returns {Object} - Current auth state
     */
    window.__TEAMIO_TEST_FIREBASE_AUTH_STATE__ = () => {
        const user = auth.currentUser;
        return {
            isAuthenticated: !!user,
            uid: user?.uid || null,
            email: user?.email || null
        };
    };

    /**
     * Test hook to initialize the Vuex store with user data
     * CRITICAL: The store's 'settings' field is initialized to null (not from localStorage)
     * so we MUST call this to properly populate the store for pages that depend on settings
     *
     * @param {Object} userData - User data from testLogin API response
     * @returns {Object} - Result object
     */
    window.__TEAMIO_TEST_INIT_STORE__ = (userData) => {
        try {
            console.log('[TEST HOOK] Initializing Vuex store with test data...');

            // Access the Vuex store through the Vue instance or import
            const vueStore = window.__teamioVue__?.$store || store;

            if (!vueStore) {
                console.error('[TEST HOOK] Could not find Vuex store');
                return { success: false, error: 'Vuex store not found' };
            }

            // Set customer module state
            if (userData.SiteID) {
                vueStore.commit('customer/setSiteID', userData.SiteID);
            }
            if (userData.CustomerID) {
                vueStore.commit('customer/setCustomerID', userData.CustomerID);
            }
            if (userData.EmployeeID) {
                vueStore.commit('customer/setUserID', userData.EmployeeID);
            }
            if (userData) {
                vueStore.commit('customer/setUser', userData);
            }

            // CRITICAL: Set settings - this is null by default and NOT loaded from localStorage
            if (userData.settings) {
                console.log('[TEST HOOK] Setting settings in store:', userData.settings.length, 'items');
                vueStore.commit('customer/setSettings', userData.settings);
            }

            // Set providers
            if (userData.providers) {
                console.log('[TEST HOOK] Setting providers in store:', userData.providers.length, 'items');
                vueStore.commit('customer/setProviders', userData.providers);
            }

            // Set other data arrays
            if (userData.sites) {
                vueStore.commit('customer/setSites', userData.sites);
            }
            if (userData.employees) {
                vueStore.commit('customer/setEmployees', userData.employees);
            }
            if (userData.lists) {
                vueStore.commit('customer/setLists', userData.lists);
            }
            if (userData.patients) {
                vueStore.commit('customer/setPatients', userData.patients);
            }

            // Set loading to false
            vueStore.commit('customer/setloading', false);

            console.log('[TEST HOOK] Vuex store initialized successfully');
            return {
                success: true,
                settings: userData.settings?.length || 0,
                providers: userData.providers?.length || 0
            };
        } catch (error) {
            console.error('[TEST HOOK] Failed to initialize store:', error);
            return { success: false, error: error.message };
        }
    };

    /**
     * Test hook to get current store state (for debugging)
     * @returns {Object} - Current store state summary
     */
    window.__TEAMIO_TEST_GET_STORE_STATE__ = () => {
        const vueStore = window.__teamioVue__?.$store || store;
        if (!vueStore) {
            return { error: 'Store not found' };
        }
        return {
            siteID: vueStore.state.customer?.siteID,
            customerID: vueStore.state.customer?.customerID,
            userID: vueStore.state.customer?.userID,
            hasSettings: !!vueStore.state.customer?.settings,
            settingsCount: vueStore.state.customer?.settings?.length || 0,
            hasProviders: !!vueStore.state.customer?.providers,
            providersCount: vueStore.state.customer?.providers?.length || 0,
            hasPatients: !!vueStore.state.customer?.patients,
            patientsCount: vueStore.state.customer?.patients?.length || 0,
            loading: vueStore.state.customer?.loading
        };
    };

    /**
     * Test hook to SEED a Team Chat room with N messages, for the scroll-back
     * (pagination) E2E. Writes to the SHARED 'teamio' Firestore project, so the
     * spec must use a dedicated test site + namespaced roomId and delete it after
     * (see __TEAMIO_TEST_DELETE_CHAT_ROOM__). Messages get strictly increasing
     * timestamps (oldest = "Seed message 1"), 1 minute apart.
     *
     * @param {Object} o - { roomId, siteID, users:string[], roomName?, count? }
     * @returns {Promise<{success:boolean, roomId?:string, count?:number, error?:string}>}
     */
    window.__TEAMIO_TEST_SEED_CHAT_ROOM__ = async (o) => {
        try {
            const { roomId, siteID, users, roomName } = o || {};
            const count = Number(o && o.count) || 30;
            if (!roomId || !siteID) throw new Error('roomId and siteID are required');
            // Rebuild the array in THIS (app window) realm: arrays passed in from a
            // Cypress spec live in a different JS realm, so Firestore's instanceof
            // Array check fails ("Unsupported field value: a custom Array object").
            let members = ['cypress-seed'];
            if (users && users.length) {
                members = [];
                for (let i = 0; i < users.length; i++) members.push(String(users[i]));
            }
            await setDoc(doc(db, 'chatrooms', roomId), {
                siteID: siteID,
                users: members,
                roomName: roomName || 'Cypress Scrollback Test',
                lastUpdated: Timestamp.now(),
            });
            const base = Date.now() - (count + 1) * 60000; // count minutes ago, 1 min apart
            for (let i = 1; i <= count; i++) {
                await addDoc(collection(db, 'chatrooms', roomId, 'messages'), {
                    sender_id: members[0],
                    content: `Seed message ${i}`,
                    timestamp: Timestamp.fromMillis(base + i * 60000),
                });
            }
            console.log(`[TEST HOOK] Seeded ${count} messages into room ${roomId}`);
            return { success: true, roomId: roomId, count: count };
        } catch (error) {
            console.error('[TEST HOOK] seed chat room failed:', error);
            return { success: false, error: error.message };
        }
    };

    /**
     * Test hook to DELETE a seeded chat room and all its messages. Always call
     * this in afterEach to keep the shared Firestore clean.
     * @param {string} roomId
     * @returns {Promise<{success:boolean, deleted?:number, error?:string}>}
     */
    window.__TEAMIO_TEST_DELETE_CHAT_ROOM__ = async (roomId) => {
        try {
            if (!roomId) throw new Error('roomId is required');
            const msgs = await getDocs(collection(db, 'chatrooms', roomId, 'messages'));
            for (const m of msgs.docs) {
                await deleteDoc(doc(db, 'chatrooms', roomId, 'messages', m.id));
            }
            await deleteDoc(doc(db, 'chatrooms', roomId));
            console.log(`[TEST HOOK] Deleted room ${roomId} (${msgs.size} messages)`);
            return { success: true, deleted: msgs.size };
        } catch (error) {
            console.error('[TEST HOOK] delete chat room failed:', error);
            return { success: false, error: error.message };
        }
    };

    console.log('[TEST HOOK] Teamio Firebase test hooks enabled (development mode)');
}